import { createStandaloneToast } from "@chakra-ui/react";
import * as Sentry from "@sentry/react";

const { toast } = createStandaloneToast();

export const onError = async (error: any) => {
  Sentry.captureException(error);
  toast({
    title: "Error",
    description:
      typeof error === "string" ? error : error?.message || error?.toString() || "An unknown error occurred.",
    status: "error",
    position: "top",
    isClosable: true,
    duration: 5000,
  });
};
